import React from 'react'
import { Box, ModalBody, ModalHeader, ModalRoot } from '@creditas-ui/react'
import { ModalFooterStyled } from './modalBanner.style'

export const ModalBanner = ({
  closeModal,
  isOpen,
  title,
  children,
  maxWidth = '1000px',
  bodyHeight = '356px',
}) => {
  return (
    <>
      <ModalRoot
        allowClose
        closeModal={closeModal}
        isOpen={isOpen}
        maxWidth={maxWidth}
      >
        <ModalHeader title={title} />
        <ModalBody resetStyle={true}>
          <Box bg="neutral.10" height={bodyHeight}>
            {children}
          </Box>
        </ModalBody>
        <ModalFooterStyled />
      </ModalRoot>
    </>
  )
}
